import MDTypography from "components/MDTypography";
import permissions from "../../../config/permissions";
import { checkPermission } from "helpers/checkPermission";
import formatCurrency from "helpers/formatCurrency";
import moment from "moment";
import MDButton from "components/MDButton";
import { approvePaymentSettlementCall, downloadPaymentSettlementPdf } from "api/api";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

export default function getPaymentSettlementTableData(settlements, reloadPage) {
  const columns = [
    { Header: "From", accessor: "from", align: "left" },
    { Header: "To", accessor: "to", align: "left" },
    { Header: "Total Amount", accessor: "amount", align: "right", minWidth: "90px" },
    { Header: "Created By", accessor: "created_user", align: "center", minWidth: "70px" },
    { Header: "Approved By", accessor: "approved_user", align: "center", minWidth: "80px" },
    { Header: "Status", accessor: "status", align: "center" },
  ];
  if (checkPermission(permissions().paymentSettlement().update().list())) {
    columns.push({
      Header: "Actions",
      accessor: "actions",
      align: "center",
    });
  }

  const approveHandler = async (id) => {
    await approvePaymentSettlementCall(id);
    reloadPage();
  };
  const onApprove = (settlement) => {
    global.showConfDialog(
      "Are you sure?",
      "This action will mark all the payments under the selected settlement is settled! Please make sure to check the payment summary before the confirmation.",
      () => {
        approveHandler(settlement.id);
      },
      ["Confirm", "Cancel"]
    );
  };

  return {
    columns: columns,
    rows: settlements.map((settlement) => {
      const approved = settlement.approved_user?.self
        ? "You"
        : settlement.approved_user?.name || "-";
      const created = settlement.created_user?.self ? "You" : settlement.created_user?.name || "-";
      const row = {
        from: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(settlement.from).format("YYYY/MM/DD hh:mm a")}
          </MDTypography>
        ),
        to: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(settlement.to).format("YYYY/MM/DD hh:mm a")}
          </MDTypography>
        ),
        amount: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {formatCurrency(settlement.amount)}
          </MDTypography>
        ),
        created_user: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {created}
          </MDTypography>
        ),
        approved_user: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {approved}
          </MDTypography>
        ),
        status: settlement.settled ? (
          <MDTypography variant="caption" color="success" fontWeight="medium">
            {"Approved"}
          </MDTypography>
        ) : (
          <MDTypography variant="caption" color="warning" fontWeight="medium">
            {"Pending"}
          </MDTypography>
        ),
      };
      if (checkPermission(permissions().paymentSettlement().update().list())) {
        row.actions = (
          <>
            {settlement.settled ? null : (
              <MDButton
                onClick={() => onApprove(settlement)}
                variant="gradient"
                color="info"
                size="small"
                style={{ marginRight: 8 }}
              >
                Approve
              </MDButton>
            )}
            <Tooltip title="Download PDF">
              <MDButton
                onClick={() => downloadPaymentSettlementPdf(settlement.id)}
                variant="gradient"
                color="info"
                size="small"
                iconOnly
                style={{ marginLeft: 8 }}
              >
                <Icon fontSize="small">picture_as_pdf</Icon>
              </MDButton>
            </Tooltip>
          </>
        );
      }
      return row;
    }),
  };
}
